// extracted by mini-css-extract-plugin
export default {"BtnLink":"BtnLink_BtnLink__xuG-D","NoWrap":"BtnLink_NoWrap__O0uaS","Small":"BtnLink_Small__32Mjh"};